import update from "immutability-helper";

import {
    SITE_DATA_REQUEST,
    SITE_DATA_REQUEST_SUCCESS,
    SITE_DATA_REQUEST_FAILURE
} from "../actions/sitedata.actions";

const initialState = {
    siteData: {},
    groupAdvisoryGroups: false,
    showIndigenousAdvisoryGroup: false,
    showCALDAdvisoryGroup: false,
    showYouthAdvisoryGroup: false,
    showConsumerAdvisoryGroup: false,
    isLoading: false
};

function loading(state, isLoading) {
    let newState = update(state, {
        isLoading: { $set: isLoading }
    });
    return newState;
}

function setSiteData(state, siteData) {

    let groupAdvisoryGroups: boolean = false;
    let showIndigenousAdvisoryGroup: boolean = false;
    let showCALDAdvisoryGroup: boolean = false;
    let showYouthAdvisoryGroup: boolean = false;
    let showConsumerAdvisoryGroup: boolean = false;
    let totalAdvisoryGroups: number = 0;
    if (siteData.aboutPeople && siteData.aboutPeople.filter(f => f.categoryId == 4).length > 0) {
        showIndigenousAdvisoryGroup = true;
        totalAdvisoryGroups++;
    }
    if (siteData.aboutPeople && siteData.aboutPeople.filter(f => f.categoryId == 7).length > 0) {
        showCALDAdvisoryGroup = true;
        totalAdvisoryGroups++;
    }
    if (siteData.aboutPeople && siteData.aboutPeople.filter(f => f.categoryId == 8).length > 0) {
        showYouthAdvisoryGroup = true;
        totalAdvisoryGroups++;
    }
    if (siteData.aboutPeople && siteData.aboutPeople.filter(f => f.categoryId == 9).length > 0) {
        showConsumerAdvisoryGroup = true;
        totalAdvisoryGroups++;
    }

    if (totalAdvisoryGroups > 1) {
        // remove all the groups
        groupAdvisoryGroups = true;
    }

    let newState = update(state, {
        siteData: { $set: siteData },
        groupAdvisoryGroups: { $set: groupAdvisoryGroups },
        showIndigenousAdvisoryGroup: { $set: showIndigenousAdvisoryGroup },
        showCALDAdvisoryGroup: { $set: showCALDAdvisoryGroup },
        showYouthAdvisoryGroup: { $set: showYouthAdvisoryGroup },
        showConsumerAdvisoryGroup: { $set: showConsumerAdvisoryGroup },
    });
    return newState;
}

export default function siteData(state = initialState, action) {
    switch (action.type) {
        case SITE_DATA_REQUEST:
            return loading(state, true);
        case SITE_DATA_REQUEST_SUCCESS:
            return setSiteData(loading(state, false), action.siteData);
        case SITE_DATA_REQUEST_FAILURE:
            return loading(state, false);
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/siteData.ts